import { render } from "./FilterBar.vue?vue&type=template&id=4b376e1c&scoped=true"
import script from "./FilterBar.vue?vue&type=script&lang=js"
export * from "./FilterBar.vue?vue&type=script&lang=js"

import "./FilterBar.vue?vue&type=style&index=0&id=4b376e1c&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b376e1c"]])

export default __exports__